import { selectorFamily, SerializableParam, useRecoilValue } from 'recoil';
import { convertInvoiceSummaries, dateRangeToDays } from 'functions';
import { InvoiceService } from 'services';
import { currentDate, isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { InvoiceSummary } from 'types';
import { DateRangeType } from 'enums';

type InvoiceSummaryParams = {
    accountId: string,
    invoiceId?: string,
    paymentId?: string,
    voucherId?: string,
    dateRange: DateRangeType,
} & SerializableParam;

export const invoiceSummaries = selectorFamily<InvoiceSummary[], InvoiceSummaryParams>({
    key: 'invoiceSummaries',
    get: ({ accountId, invoiceId, paymentId, voucherId, dateRange }) =>
        async ({ get }) => {
            get(currentDate);
            get(refreshState(invoiceSummaries({ accountId, invoiceId, paymentId, voucherId, dateRange }).key))
            if (get(isAuthenticated) && accountId) {
                const service = new InvoiceService();
                const data = await service.getInvoiceSummaries(accountId, voucherId ?? '', paymentId ?? '', invoiceId ?? '', `-${dateRangeToDays(dateRange)}`);
                return convertInvoiceSummaries(data);
            }
            return [];
        }
});

export const useInvoiceSummaries = (
    accountId: string,
    invoiceId?: string,
    paymentId?: string,
    voucherId?: string,
    dateRange: DateRangeType = DateRangeType.OneYear
) => useRecoilValue(invoiceSummaries({ accountId, invoiceId, paymentId, voucherId, dateRange }));

export const useInvoiceSummariesByDateRange = (
    accountId: string,
    dateRange: DateRangeType = DateRangeType.OneYear
) => useInvoiceSummaries(accountId, undefined, undefined, undefined, dateRange);

export const useRefreshInvoiceSummaries = (
    accountId: string,
    invoiceId?: string,
    paymentId?: string,
    voucherId?: string,
    dateRange: DateRangeType = DateRangeType.OneYear
) => useSetRefreshState(invoiceSummaries({ accountId, invoiceId, paymentId, voucherId, dateRange }));
